import React, { useEffect, useMemo } from 'react';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getAPI } from 'store/apiReducer';
import { SelectControl } from '@si-armes/dsfr-react';
import usagerClientReducer from '../../../../store/usagerReducer';
import {
    API_GET_REFERENTIEL_DEPARTEMENTS,
    CONTEXT_GET_REFERENTIEL_DEPARTEMENTS,
} from '../../../../constants/apiUrls.constants';
import { formaterOptions } from '../../../../utils/utils';

const SelectDepartements = ({
    referentielDepartements,
    getApi,
    isLoading,
    name,
    label,
    texteAide,
    placeholder,
    error,
    warning,
    valid,
    disabled,
    required,
    onChange,
    register,
    ...otherProps
}) => {
    const getDepartements = () => {
        getApi(
            usagerClientReducer,
            API_GET_REFERENTIEL_DEPARTEMENTS,
            CONTEXT_GET_REFERENTIEL_DEPARTEMENTS,
        );
    };

    useEffect(() => {
        if (
            isLoading === null &&
            (!referentielDepartements || Object.keys(referentielDepartements).length === 0)
        ) {
            getDepartements();
        }
    }, [referentielDepartements, getDepartements]);

    const optionsDepartement = useMemo(() => {
        if (referentielDepartements) {
            return referentielDepartements.map((element) => {
                return {
                    key: element.id,
                    value: element.code,
                    libelle: `${element.code} - ${element.libelle}`,
                };
            });
        }
        return [];
    }, [referentielDepartements]);

    return (
        <SelectControl
            name={name}
            label={label}
            texteAide={texteAide}
            placeholder={referentielDepartements ? placeholder : 'Chargement en cours...'}
            error={error}
            warning={warning}
            valid={valid}
            disabled={disabled}
            required={required}
            onChange={onChange}
            {...register}
            {...otherProps}
            options={formaterOptions(optionsDepartement)}
        />
    );
};

SelectDepartements.propTypes = {
    name: PropTypes.string.isRequired,
    referentielDepartements: PropTypes.array,
    getApi: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    label: PropTypes.string,
    texteAide: PropTypes.string,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    placeholder: PropTypes.string,
    /** Fonction register de React Hook Form */
    register: PropTypes.shape({
        onChange: PropTypes.func.isRequired,
        onBlur: PropTypes.func.isRequired,
        name: PropTypes.string.isRequired,
        ref: PropTypes.any.isRequired,
    }),
    onChange: PropTypes.func,
    error: PropTypes.shape({
        message: PropTypes.string.isRequired,
    }),
    warning: PropTypes.shape({
        message: PropTypes.string.isRequired,
    }),
    valid: PropTypes.shape({
        message: PropTypes.string.isRequired,
    }),
};

SelectDepartements.defaultProps = {
    label: null,
    disabled: false,
    required: false,
    texteAide: null,
    placeholder: '-- Choisir une option --',
    onChange: null,
    isLoading: null,
    referentielDepartements: null,
};

export default connect(
    (state) => {
        const { isLoading, erreur, data, message } = state.referentiel.departements;
        return {
            isLoading,
            erreur,
            referentielDepartements: data,
            message,
        };
    },
    {
        getApi: getAPI,
    },
)(SelectDepartements);
